import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import shuffle from 'lodash/shuffle';
import {
  ColumnBlock,
  ColumnContent,
  ContentSection,
} from '../../layout/components';
import { Icon } from '../../../icons';
import styles from '../../../styles';

const TidBitSection = styled(ContentSection)`
  h2 {
    color: ${styles.color.SLATE};
  }
`;

const TidBitContainer = styled(ColumnBlock)``;

const TidBit = styled(ColumnContent)`
  display: flex;
  flex-direction: row;
  padding-bottom: 4.5rem;
`;
const TidBitFigure = styled.figure`
  width: 6.25rem;
  height: 6.25rem;
  margin: 0 1rem 0 0.5rem;

  svg {
    stroke: ${styles.color.ORANGE};
    stroke-width: 1.5;
    fill: none;
  }
`;
const TidBitContent = styled.div`
  display: flex;
  flex-direction: column;
`;
const TidBitNumber = styled.h3`
  font-family: 'ApercuLight' !important;
  font-size: 4.5rem;
  margin-bottom: 0.25rem !important;
`;
const TidBitDescription = styled.span`
  font-family: 'ApercuMono';
  font-size: 1.125rem;
  line-height: 1.25rem;
  text-transform: uppercase;
`;

const TidBits = ({ title, facts, range }) => {
  let randomFacts = facts;
  if (facts.length > 6) {
    randomFacts = shuffle(randomFacts).slice(0, 6);
  }
  const rand = (min, max) => {
    let val = min;
    try {
      min = parseInt(min, 10);
      max = parseInt(max, 10);

      val = min + Math.round(Math.random() * (max - min));
    } catch (e) {}
    return val;
  };
  return (
    <TidBitSection>
      <ColumnBlock columns={1}>
        <ColumnContent>
          <h2>{title}</h2>
        </ColumnContent>
      </ColumnBlock>
      <TidBitContainer columns={3} flex>
        {randomFacts.map((fact, index) => {
          return (
            <ColumnBlock key={index} parentColumns={3}>
              <TidBit>
                <TidBitFigure>
                  <Icon icon={`#${fact.icon}`} />
                </TidBitFigure>
                <TidBitContent>
                  <TidBitNumber>
                    {!range
                      ? fact.number
                      : rand(fact.number_min, fact.number_max)}
                  </TidBitNumber>
                  <TidBitDescription>{fact.description}</TidBitDescription>
                </TidBitContent>
              </TidBit>
            </ColumnBlock>
          );
        })}
      </TidBitContainer>
    </TidBitSection>
  );
};

TidBits.propTypes = {
  title: PropTypes.string.isRequired,
  facts: PropTypes.array.isRequired,
  range: PropTypes.bool,
};

export default TidBits;



// WEBPACK FOOTER //
// ./src/modules/pages/components/TidBits.js